import { createSelector } from 'reselect'

const innerStateSelector = state => state.notifications

const listSelector = createSelector(
   innerStateSelector,
   (state) => (state.list)
);

const unseenNotificationsCountSelector = createSelector(
   innerStateSelector,
   (state) => {
      let count = state.unseenCount;
      if(count > 99){
         count = '99+'
      }
      return {
         count: state.unseenCount,
         badgeCount: count,
      };
   }
);

const unreadNotificationsCountSelector = createSelector(
   innerStateSelector,
   (state) => (state.unreadCount)
);

const isFetchingNotificationsSelector = createSelector(
   innerStateSelector,
   (state) => (state.isFetchingNotifications)
);

const isFetchingNewNotificationsSelector = createSelector(
   innerStateSelector,
   (state) => (state.isFetchingNewNotifications)
);

const notificationsPanelSelector = createSelector(
   innerStateSelector,
   (state) => (state.notificationsPanel)
);

const isEmptyNotificationsSelector = createSelector(
   innerStateSelector,
   (state) => (state.isEmptyNotifications)
);

const isEmptyByFilterNotificationsSelector = createSelector(
   innerStateSelector,
   (state) => (state.isEmptyByFilterNotifications)
);

const isFetchingByFilterNotificationsSelector = createSelector(
   innerStateSelector,
   (state) => (state.isFetchingByFilterNotifications)
);

export {
   listSelector,
   unseenNotificationsCountSelector,
   unreadNotificationsCountSelector,
   isFetchingNotificationsSelector,
   isFetchingNewNotificationsSelector,
   notificationsPanelSelector,
   isEmptyNotificationsSelector,
   isEmptyByFilterNotificationsSelector,
   isFetchingByFilterNotificationsSelector,
}
